// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HuddleTasksSection-module__section___RfAQ7 {
  scroll-margin-top: 120px;
}

.HuddleTasksSection-module__groupBand___TzlAs {
  padding-left: 20px;
  padding-right: 20px;
}

.HuddleTasksSection-module__emptyRow___j21xK {
  padding: 16px 20px;
  font-size: 14px;
  color: #71717a;
}

.HuddleTasksSection-module__rows___pEedh > * + * {
  border-top: 1px solid #e4e4e7;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/HuddleTasksSection/HuddleTasksSection.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,6BAAA;AACF","sourcesContent":[".section {\n  scroll-margin-top: 120px;\n}\n\n.groupBand {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.emptyRow {\n  padding: 16px 20px;\n  font-size: 14px;\n  color: #71717a;\n}\n\n.rows > * + * {\n  border-top: 1px solid #e4e4e7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `HuddleTasksSection-module__section___RfAQ7`,
	"groupBand": `HuddleTasksSection-module__groupBand___TzlAs`,
	"emptyRow": `HuddleTasksSection-module__emptyRow___j21xK`,
	"rows": `HuddleTasksSection-module__rows___pEedh`
};
module.exports = ___CSS_LOADER_EXPORT___;
